export default __webpack_public_path__ + "static/media/2.dcb2e5cc.png";